


























import { Component, Vue } from 'vue-property-decorator'
import {
  get1stAndToday,
  past7Day,
  past30Day,
  pastWeek,
  pastMonth,
} from '@/utils/formValidate'
import {
  getDataOverView, //数据概览
  getUserStatistics1,
  getUserStatistics2,
  getUserStatistics3,
  getTop,
} from '@/api/index'
// 组件
// 标题
import TitleIndex from './components/titleIndex.vue'
// 营业额统计
import TurnoverStatistics from './components/turnoverStatistics.vue'
// 用户统计
import UserStatistics1 from './components/userStatistics1.vue'
import UserStatistics2 from './components/userStatistics2.vue'
import UserStatistics3 from './components/userStatistics3.vue'
// 订单统计
import OrderStatistics from './components/orderStatistics.vue'
// 排名
import Top from './components/top10.vue'
@Component({
  name: 'Dashboard',
  components: {
    TitleIndex,
    UserStatistics1,
    UserStatistics2,
    UserStatistics3,
    Top,
  },
})
export default class extends Vue {
  private overviewData = {} as any
  private flag = 2
  private tateData = []
  private userData1 = {}
  private userData2 = {}
  private userData3 = {}

  private top10Data = {}
  created() {
    //this.init(this.flag)
    this.getTitleNum(2);
  }
  // 获取基本数据
  init(begin: any,end:any) {
    this.$nextTick(() => {
      // this.getTurnoverStatisticsData(begin,end)
      this.getUserStatistics1Data(begin,end)
      this.getUserStatistics2Data(begin,end)
      this.getUserStatistics3Data(begin,end)
      // this.getOrderStatisticsData(begin,end)
      this.getTopData(begin,end)
    })
  }
/* 
  // 获取营业额统计数据
  async getTurnoverStatisticsData(begin: any ,end:any) {
    const data = await getTurnoverStatistics({ begin: begin,end:end })
    const turnoverData = data.data.data
    this.turnoverData = {
      dateList: turnoverData.dateList.split(','),
      turnoverList: turnoverData.turnoverList.split(',')
    }
    // this.tateData = this.turnoverData.date
    // const arr = []
    // this.tateData.forEach((val) => {
    //   let date = new Date()
    //   let year = date.getFullYear()
    //   arr.push(year + '-' + val)
    // })
    // this.tateData = arr
  } */
  // 获取用户统计数据
  async getUserStatistics1Data(begin: any ,end:any) {
    const data = await getUserStatistics1({ begin: begin,end:end })
    const userData1 = data.data.data
    console.log(userData1)
    this.userData1 = {
      dateList: userData1.dateList.split(','),
      totalUserList: userData1.totalUserList.split(','),
      newUserList: userData1.newUserList.split(','),
    }
  }  // 获取用户统计数据
  async getUserStatistics2Data(begin: any ,end:any) {
    const data = await getUserStatistics2({ begin: begin,end:end })
    const userData2 = data.data.data
    console.log(userData2)
    this.userData2 = {
      dateList: userData2.dateList.split(','),
      totalUserList: userData2.totalUserList.split(','),
      newUserList: userData2.newUserList.split(','),
    }
  }  // 获取用户统计数据
  async getUserStatistics3Data(begin: any ,end:any) {
    const data = await getUserStatistics3({ begin: begin,end:end })
    const userData3 = data.data.data
    console.log(userData3)
    this.userData3 = {
      dateList: userData3.dateList.split(','),
      totalUserList: userData3.totalUserList.split(','),
      newUserList: userData3.newUserList.split(','),
    }
  }
/*   // 获取订单统计数据
  async getOrderStatisticsData(begin: any ,end:any) {
    const data = await getOrderStatistics({begin: begin,end:end })
    const orderData = data.data.data
    this.orderData = {
      data: {
        dateList: orderData.dateList.split(','),
        orderCountList: orderData.orderCountList.split(','),
        validOrderCountList: orderData.validOrderCountList.split(','),
        //orderCompletionRateList: orderData.orderCompletionRateList.split(','),
      },
      totalOrderCount: orderData.totalOrderCount,
      validOrderCount: orderData.validOrderCount,
      orderCompletionRate: orderData.orderCompletionRate
    }
  } */
  // 获取排行数据
  async getTopData(begin: any ,end:any) {
    const data = await getTop({begin: begin,end:end })
    const top10Data = data.data.data
    this.top10Data = {
      nameList: top10Data.nameList.split(',').reverse(),
      numberList: top10Data.numberList.split(',').reverse(),
    }
    console.log(this.top10Data)
  }
  // 获取当前选中的tab时间
  getTitleNum(data) {
    switch (data) {
      case 1:
        this.tateData = get1stAndToday()
        break
      case 2:
        this.tateData = past7Day()
        break
      case 3:
        this.tateData = past30Day()
        break
      case 4:
        this.tateData = pastWeek()
        break
      case 5:
        this.tateData = pastMonth()
        break
    }
    this.init(this.tateData[0],this.tateData[1])
  }
}
